export default __webpack_public_path__ + "static/media/pegasus-header-background.67864055.jpg";